import { render, staticRenderFns } from "./CoffeeSizeDetails.vue?vue&type=template&id=eb92273c"
import script from "./CoffeeSizeDetails.vue?vue&type=script&lang=js"
export * from "./CoffeeSizeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports